import { render, staticRenderFns } from "./OcrReviewModal.vue?vue&type=template&id=8a6032a8&scoped=true"
import script from "./OcrReviewModal.vue?vue&type=script&lang=js"
export * from "./OcrReviewModal.vue?vue&type=script&lang=js"
import style0 from "./OcrReviewModal.vue?vue&type=style&index=0&id=8a6032a8&prod&lang=css"
import style1 from "./OcrReviewModal.vue?vue&type=style&index=1&id=8a6032a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6032a8",
  null
  
)

export default component.exports